module.exports = __webpack_public_path__ + "static/media/merge.40985151.png";